// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { ref, getDownloadURL, uploadBytes } from "firebase/storage";
import { Timestamp, addDoc, collection } from "firebase/firestore";

import { getAuth, signInWithPopup, GoogleAuthProvider, signOut } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebaseApp);
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);

export const auth = getAuth(firebaseApp);
export const provider = new GoogleAuthProvider();



export const fetchImageUrl = async (imagePath: string): Promise<string> => {
  const imageRef = ref(storage, `gs://goldenteacher-uk.appspot.com/Gigs/${imagePath}`);
  try {
    const url = await getDownloadURL(imageRef);
    console.error('Image URL: ', url);
    return url;
  } catch (error) {
    console.error('Error fetching image: ', error);
    throw new Error('Failed to fetch image.');
  }
};



export const signInWithGooglePopup = (): Promise<void> => {
  return signInWithPopup(auth, provider)
    .then((result) => {
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const token = credential?.accessToken ?? "";
      const user = result.user;
      // Handle successful sign in
      // Optionally, return some value or result here
    })
    .catch((error) => {
      // Handle or re-throw error
      throw error; // Re-throwing the error to be handled by the caller
    });
};

export const signOutUser = () => {
  return signOut(auth)
    .then(() => {
      // Sign-out successful.
      // Optionally, handle post sign-out actions here
    }).catch((error) => {
      // An error happened during sign out
      // Handle or log the error
      console.error("Sign out error:", error);
    });
};

const uploadImage = async (file: File, path: string): Promise<string> => {
  const imageRef = ref(storage, `gs://goldenteacher-uk.appspot.com/Gigs/${path}`);

  try {
    // Upload the file to the specified path in Firebase Storage
    const snapshot = await uploadBytes(imageRef, file);
    
    // After upload, get the download URL
    const url = await getDownloadURL(snapshot.ref);
    return url;
  } catch (error) {
    console.error('Error uploading image: ', error);
    throw new Error('Failed to upload image.');
  }
};

const ToStringDate = (date: Timestamp) =>  {
  const dateObject = date.toDate();
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric', // or '2-digit'
    month: 'long', // 'short' for abbreviated month name or 'numeric' for number
    day: 'numeric' // or '2-digit'
  };
  return dateObject.toLocaleDateString(undefined, options);
}

export const addNewGig = async (title: string, date: Date, imagePath: string, imageFile: File): Promise<void> => {
  
  // Set date to be at 9pm
  date.setHours(21);

  // Convert date to Timestamp
  const timestamp = Timestamp.fromDate(date);

  // get image filename from image path
  console.log(`Image Path: ${imageFile.name}`);
  const filename = imageFile.name.split('/').pop();
  var imageName = title.replaceAll('/', '_') + '-' + ToStringDate(timestamp) + '-' + filename;
  imageName = imageName.replaceAll(' ', '_');
  console.log(`Image Name: ${imageName}`);
  
  // Upload image to storage
  //const file: File = new File([imagePath], imageName);
  uploadImage(imageFile, imageName);

  // Add gig to Firestore
  const docRef = await addDoc(collection(db, "Gigs"), {
    title: title,
    date: timestamp,
    image: imageName
  });
  console.log("Document written with ID: ", docRef.id);
}